import path from 'path';

export const url = (image) => {
    if(image && image.includes('https://')) 
        return image;

    return path.join( '/' , process.env.PUBLIC_URL , 'assets/images', image);
}

export const urlPublic = () => {
    return path.join( '/' , process.env.PUBLIC_URL);
}

export const urlLogOut = () => {
    return path.join( '/' , process.env.PUBLIC_URL, 'auth/logout');
}


// WEBPACK FOOTER //
// ./src/helper/image.js